<div class="rank">
  <div class="rank_number">
    {{ params.value ? params.value.toLocaleString("en") : "" }}
  </div>
  <div class="rank_catagory">{{ params.data.Category }}</div>
</div>
